module.exports = __webpack_public_path__ + "media/images/logo-912b35212a28709a9ce81236797bbe64.png";